import { render } from "./CommonHotArticleList.vue?vue&type=template&id=5348f039"
import script from "./CommonHotArticleList.vue?vue&type=script&lang=js"
export * from "./CommonHotArticleList.vue?vue&type=script&lang=js"

import "./CommonHotArticleList.vue?vue&type=style&index=0&id=5348f039&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__